<div class="webhooks-detail-component scroll-container fullpage">

  <div class="row">

    <!-- Left Column -->
    <left-column class="col-auto left-column invisible"
      [identifiers]="['filter']"
      [icons]="['filter']"
      #lc>
      @if (lc.show === 'filter' || !lc.show) {
        <filter-column
          [listFilter]=listFilter
          [filterConfig]="filterColumnConfig">
        </filter-column>
      }
    </left-column>
    <!-- Left Column end -->

    <!-- Content Column -->
    <div class="col content-col">
      <div class="row">
        <div class="col-sm-12">
          <div class="card-deck">

            <!-- Webhook -->
            @if (webhook) {
              <div class="card mb-3">
                <div class="card-header">
                  @if (!error && webhook) {
                    <span>{{ webhook.name }}</span>
                  }
                </div>
                <div class="card-body">
                  <div class="table-responsive table-borderless">
                    <table class="table first-column-md mb-0">
                      <tbody>
                        <tr>
                          <th i18n="@@components.webhooks.webhook">Webhook:</th>
                          <td>
                            <fa-icon [icon]="['fas', 'copy']"
                              transform="shrink-2"
                              ngxClipboard
                              [cbContent]="webhook.url"
                              class="pointer"
                              tooltip="Copy to Clipboard"
                              i18n-tooltip="@@components.webhooks.copy_to_clipboard">
                            </fa-icon>
                            {{ webhook.url }}
                          </td>
                        </tr>
                        <tr>
                          <th i18n="@@components.webhooks.tenant">Tenant:</th>
                          <td>
                            <span>{{ webhook.tenant_id }}</span><br>
                          </td>
                        </tr>
                        <th i18n="@@components.webhooks.active">Active:</th>
                        <td>
                          @if (webhook.active) {
                            <fa-icon [icon]="['fas', 'check']"
                              transform="shrink-2"
                              >
                            </fa-icon>
                          }
                        </td>
                        <tr>
                          <th class="align-top" i18n="@@components.webhooks.headers_title">Headers:</th>
                          <td>
                            @for (header of webhook.headers | iterateObject; track header) {
                              <div>{{ header.key }}: {{ header.value }}</div>
                            }
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <default-dates [created_at]="webhook.created_at" [updated_at]="webhook.updated_at" [precision]="'m'"></default-dates>
                  </div>
                </div>
              </div>
            } @else {
              <div class="alert alert-warning" i18n="@@common.no_result">No result</div>
            }
            <!-- Webhook end -->

            <!-- Topic -->
            @if (webhook) {
              <div class="card mb-3">
                <div class="card-header">
                  @if (!error && webhook) {
                    <span i18n="@@components.webhooks.topics">Topics</span>
                  }
                </div>
                <div class="card-body">
                  <div class="table-responsive table-borderless">
                    <table class="table first-column-md mb-0">
                      <tbody>
                        @for (topic of webhook.topics; track topic) {
                          <tr class="bg-light padding-left-10 border-top border-white border-top-5">
                            <th i18n="@@components.webhooks.name">Name:</th>
                            <td>
                              <span>{{ topic.name }}</span><br>
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            } @else {
              <div class="alert alert-warning" i18n="@@common.no_result">No result</div>
            }
            <!-- Topic end -->

          </div>
        </div>
      </div>

      <!-- Event -->
      @if (events?.getModels().length > 0) {
        <div class="card mb-3">
          <div class="card-header">
            <span i18n="@@components.webhooks.events">Events</span>
            <span class="invisible">
              <filter-sorting [listFilter]="listFilter"
                [filterConfig]="filterColumnConfig"
              ></filter-sorting>
            </span>
          </div>
          <div class="card-body">
            <div class="table-responsive table-borderless">
              <table class="table first-column-md mb-0">
                <tbody>
                  @for (event of events.getModels(); track event) {
                    <tr class="bg-light padding-left-10 border-top border-white border-top-5 pointer"
                      (click)="isCollapsed[event.id] = !isCollapsed[event.id]">
                      <td class="u-nowrap">
                        <fa-icon [icon]="['fas', 'upload']"
                          transform="shrink-2"
                          [fixedWidth]="true"
                          tooltip="{{ event.created_at | pdcDate: { precision: 's' } }}">
                        </fa-icon>
                        <span [dateFromNow]="event.created_at" [precision]="'s'"></span><br>
                      </td>
                      <td><b>{{ event.event_type }}</b></td>
                      <td><b i18n="@@components.webhooks.document_id">Document ID:</b> {{ event.getPayload().attributes?.document_id}}</td>
                      <td><b i18n="@@components.webhooks.batch_id">Batch ID:</b> {{ event.getPayload().attributes?.batch_id}}</td>
                      <td><b i18n="@@components.webhooks.status">Status:</b> {{ event.logs[0]?.http_status }} {{ event.status }}</td>
                      <td><b i18n="@@components.webhooks.attempts">Attempts:</b> {{ event.logs?.length || 1 }}</td>
                      <td>
                        <div class="col-auto text-end">
                          @if (!isCollapsed[event.id]) {
                            <fa-icon [icon]="['fas', 'arrow-alt-circle-down']"
                              [fixedWidth]="true"
                              >
                            </fa-icon>
                          }
                          @if (isCollapsed[event.id]) {
                            <fa-icon [icon]="['fas', 'arrow-alt-circle-up']"
                              [fixedWidth]="true"
                              >
                            </fa-icon>
                          }
                        </div>
                      </td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th i18n="@@components.webhooks.request_id">Request ID:</th>
                      <td colspan="5">
                        <span>{{ event.request_id }}</span><br>
                      </td>
                      <td></td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th class="align-top" i18n="@@components.webhooks.payload">Payload:</th>
                      <td colspan="5">
                        <pre>{{ event.parseJSON(event.payload) }}</pre>
                      </td>
                      <td></td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th i18n="@@components.webhooks.failure_reason">Failure reason:</th>
                      <td colspan="5">
                        <span>{{ event.failure_reason }}</span><br>
                      </td>
                      <td></td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th i18n="@@components.webhooks.status">Status:</th>
                      <td colspan="5">
                        <span>{{ event.status }}</span><br>
                      </td>
                      <td></td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th i18n="@@components.webhooks.attempts">Attempts:</th>
                      <td colspan="5">
                        <span>{{ event.attempts }}</span><br>
                      </td>
                      <td></td>
                    </tr>
                    <tr [hidden]="!isCollapsed[event.id]" class="bg-light padding-left-10">
                      <th class="align-top" i18n="@@components.webhooks.logs">Logs:</th>
                      <td colspan="5">
                        <table class="table-responsive first-column-md mb-0">
                          <tbody>
                            @for (log of event.logs; track log) {
                              <tr class="bg-light padding-left-10">
                                <th i18n="@@components.webhooks.created_at">Created at:</th>
                                <td class="u-nowrap">
                                  <fa-icon [icon]="['fas', 'upload']"
                                    transform="shrink-2"
                                    [fixedWidth]="true"
                                    tooltip="{{ log.created_at | pdcDate: { precision: 'ms' } }}">
                                  </fa-icon>
                                  <span [dateFromNow]="log.created_at" [precision]="'ms'"></span><br>
                                </td>
                                <th class="u-nowrap" i18n="@@components.webhooks.http_status">HTTP Status:</th>
                                <td>
                                  <span>{{ log.http_status }}</span><br>
                                </td>
                                <th class="u-nowrap" i18n="@@components.webhooks.http_body">HTTP Body:</th>
                                <td>
                                  <span>{{ log.http_body }}</span><br>
                                </td>
                              </tr>
                            }
                          </tbody>
                        </table>
                      </td>
                      <td></td>
                    </tr>
                  }
                </tbody>
              </table>
              @if (events?.getModels().length > 0) {
                <div>
                  <list-pagination
                    [totalItems]="events?.getMeta().meta.stats.total.count"
                    [filterComponent]="filterComponent"
                    [pageNumber]="listFilter.page.number"
                    [pageSize]="listFilter.page.size"
                  ></list-pagination>
                </div>
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="alert alert-warning">
          @if (loading) {
            <fa-icon class="me-1" [icon]="['fas', 'sync-alt']" [fixedWidth]="true" animation="spin"></fa-icon>
          }
          @if (loading) {
            <ng-container i18n="@@common.loading_text">We're loading… please wait.</ng-container>
          } @else {
            <ng-container i18n="@@common.no_result">No result</ng-container>
          }
        </div>
      }
      <!-- Event end -->

      <!-- No Result -->
      <!-- No Result end -->

      <!-- No Event Result -->
      <!-- No Event Result end -->

    </div>
    <!-- Content Column end -->

  </div>
</div>
